import Pino from 'pino';

/**
 * Pino logger instance that can be used in any runtime environment.
 *
 * Note that an injectable logger instance should always preferable to this.
 */
export const logger = Pino({
  browser: {
    asObject: true,
    serialize: true,
  },
  enabled: process.env.NODE_ENV !== 'test',
});
